// @ts-nocheck
import { BitBucket } from '@atlassian/temp-proxies';
import React, { createContext, useContext, useEffect, useReducer } from 'react';
import { useParams } from 'react-router-dom';
import {
  adminInitialState,
  adminReducer,
  fetchAdminFailed,
  fetchInitialAdmins,
  fetchMoreAdmin,
} from '../../../support/entitlements/bitbucket/containers/bitbucket-page/state/bitbucket-admins';
import {
  fetchGroupMembershipFailed,
  fetchInitialGroupMemberships,
  fetchMoreGroupMembership,
  groupMembershipInitialState,
  groupMembershipReducer,
} from '../../../support/entitlements/bitbucket/containers/bitbucket-page/state/bitbucket-group-memberships';
import {
  fetchInitialUsers,
  fetchMoreUser,
  fetchUserFailed,
  userInitialState,
  userReducer,
} from '../../../support/entitlements/bitbucket/containers/bitbucket-page/state/bitbucket-users';

export const BitbucketTabContext = createContext<any>(undefined);

export const useBitbucketTabContext = () => {
  const context = useContext(BitbucketTabContext);
  if (!context) {
    throw new Error('context has not been setup');
  }
  return context;
};

export const BitbucketTabContextProvider = ({ children }: React.PropsWithChildren<unknown>) => {
  const { bitbucketUuid: id } = useParams<{ bitbucketUuid: string }>();

  const [userState, userDispatch] = useReducer(userReducer, userInitialState);
  const [adminState, adminDispatch] = useReducer(adminReducer, adminInitialState);
  const [groupMembershipState, groupMembershipDispatch] = useReducer(
    groupMembershipReducer,
    groupMembershipInitialState
  );

  const getParams = (offset = 0) => {
    const searchOptions = {
      from: offset,
      size: 25,
      sort: [{ _score: 'desc' }, { business_key: 'asc' }],
    };
    return {
      searchOptions,
      id,
    };
  };

  //For users
  useEffect(() => {
    async function fetchData() {
      try {
        const params = getParams();
        const data = await BitBucket.fetchAccountUsers(params);
        userDispatch(fetchInitialUsers(data));
      } catch (error: any) {
        userDispatch(fetchUserFailed(error));
      }
    }
    fetchData();
  }, []);

  //For Admins
  useEffect(() => {
    async function fetchAdminData() {
      try {
        const params = getParams();
        const data = await BitBucket.fetchAccountAdmins(params);
        adminDispatch(fetchInitialAdmins(data));
      } catch (error: any) {
        adminDispatch(fetchAdminFailed(error));
      }
    }
    fetchAdminData();
  }, []);

  //For Group Membership
  useEffect(() => {
    async function fetchData() {
      try {
        const params = getParams();
        const data = await BitBucket.fetchGroupMemberships(params);
        groupMembershipDispatch(fetchInitialGroupMemberships(data));
      } catch (error: any) {
        groupMembershipDispatch(fetchGroupMembershipFailed(error));
      }
    }
    fetchData();
  }, []);

  const fetchMoreUsers = async (offset: number) => {
    const params = getParams(offset);
    const data = await BitBucket.fetchAccountUsers(params);
    userDispatch(fetchMoreUser(data));
  };

  const fetchMoreAdmins = async (offset: number) => {
    const params = getParams(offset);
    const data = await BitBucket.fetchAccountAdmins(params);
    adminDispatch(fetchMoreAdmin(data));
  };

  const fetchMoreGroupMemberships = async (offset: number) => {
    const params = getParams(offset);
    const data = await BitBucket.fetchGroupMemberships(params);
    groupMembershipDispatch(fetchMoreGroupMembership(data));
  };

  return (
    <BitbucketTabContext.Provider
      value={{
        userState,
        fetchMoreUsers,
        adminState,
        fetchMoreAdmins,
        groupMembershipState,
        fetchMoreGroupMemberships,
      }}
    >
      {children}
    </BitbucketTabContext.Provider>
  );
};
